import React from 'react';
import { useSelector } from 'react-redux';
import { IconContext } from 'react-icons/lib';
import { BsChevronDown } from 'react-icons/bs';
import Div100vh from 'react-div-100vh';
import { ADAWidgitRoles } from '../../../models/ADA';
import './CardHolder.scss';

function CardHolder({ index, children, isInlineCard, cardHeight, isLightBg, onArrowClicked, hasArrow, active, specialClass }) {
  var classname = 
    (isInlineCard ? 'home__story-section carousel-inline' : 'home__story-section carousel-fullscreen') + 
    (isLightBg ? ' lightBg' : ' darkBg') + 
    (specialClass ? ` ${specialClass}` : '');
  const inFullScreenVideo = useSelector(state => state.data.inFullScreenVideo);
  const menuOpened = useSelector(state => state.data.menuOpened);

  var innerDiv = (
    <div className={`container ${inFullScreenVideo ? 'full-screen-video' : ''}`}>
      {children}
      {hasArrow ? (
        <BsChevronDown
          className="arrow-icon"
          role={ADAWidgitRoles.Button}
          aria-label="Next"
          tabIndex={!menuOpened ? 0 : -1}
          onKeyUp={(e) => {
            if (e.key === 'Enter' && e.target === document.activeElement) {
                onArrowClicked(index);
            }
          }}
          onClick={() => onArrowClicked(index)}
        />
      ) : null}
    </div>
  );

  return (
    <>
      <IconContext.Provider value={{ color: '#fff' }}>
        <div className={classname}>
          {isInlineCard ? 
            <div style={{height: cardHeight+"px"}}>
              {innerDiv}
            </div> :
            <Div100vh>
              {innerDiv}
            </Div100vh>
            }
        </div>
      </IconContext.Provider>
    </>
  );
}
export default CardHolder;
